module.exports = __webpack_public_path__ + "img/jiandingbao.9d295d77.jpg";